import axios from 'axios'

const STATUS_LABELS = {
  pending: '审核中',
  need_info: '待补充材料',
  approved: '已退款',
  rejected: '已拒绝',
  cancelled: '已取消'
}

export function appealStatusLabel(status) {
  return STATUS_LABELS[status] || status || '—'
}

export async function fetchPurchaseRefundConfig() {
  const res = await axios.get('/api/v1/purchase/refund/config')
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '加载申诉配置失败')
  }
  return res.data.data || {}
}

export async function submitPurchaseRefundAppeal({ orderNo, reason, imageUrls }) {
  const res = await axios.post('/api/v1/purchase/refund/appeal/submit', {
    orderNo,
    reason,
    imageUrls: imageUrls || []
  })
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '提交申诉失败')
  }
  return res.data.data
}

export async function supplementPurchaseRefundAppeal({ appealId, reason, imageUrls }) {
  const res = await axios.post('/api/v1/purchase/refund/appeal/supplement', {
    appealId,
    reason,
    imageUrls: imageUrls || []
  })
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '补充材料失败')
  }
  return res.data.data
}

export async function fetchPurchaseRefundAppeal(orderNo) {
  const res = await axios.get('/api/v1/purchase/refund/appeal', { params: { orderNo } })
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '查询申诉失败')
  }
  return res.data.data
}

export async function fetchAdminPurchaseRefundAppeals({ page = 1, pageSize = 20, status = '', orderNo = '', userId = 0 } = {}) {
  const res = await axios.post('/api/v1/admin/purchase/refund/appeals/list', {
    page,
    pageSize,
    status: status || undefined,
    orderNo: orderNo || undefined,
    userId: userId || undefined
  })
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '加载申诉列表失败')
  }
  return res.data.data || { items: [], total: 0 }
}

export async function processAdminPurchaseRefundAppeal({ appealId, action, adminReply }) {
  const res = await axios.post('/api/v1/admin/purchase/refund/appeals/process', {
    appealId,
    action,
    adminReply: adminReply || undefined
  })
  if (res.data?.code !== 200) {
    throw new Error(res.data?.message || '处理失败')
  }
  return res.data.data
}
